import { render, staticRenderFns } from "./RegisterCustomer.vue?vue&type=template&id=cc92c000&scoped=true"
import script from "./RegisterCustomer.vue?vue&type=script&lang=js"
export * from "./RegisterCustomer.vue?vue&type=script&lang=js"
import style0 from "./RegisterCustomer.vue?vue&type=style&index=0&id=cc92c000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc92c000",
  null
  
)

export default component.exports